import { motion } from "framer-motion";
import { PartyPopper, MessageCircle, Phone } from "lucide-react";

export default function Events({ content }) {
  if (!content.events_image && !content.events_text) return null;
  const wa = (content.whatsapp || "").replace(/[^\d]/g, "");
  return (
    <section id="eventos" className="relative py-24 md:py-36 bg-[#f9f6f0]">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, scale: 0.96 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="relative overflow-hidden shadow-[0_12px_40px_rgba(0,0,0,0.15)] order-1 lg:order-none"
          >
            {content.events_image && (
              <img src={content.events_image} alt="Catering y eventos" className="w-full h-full object-cover" loading="lazy" />
            )}
            <span className="absolute top-4 left-4 rounded-full bg-[#da251d] text-white text-xs font-bold uppercase tracking-widest px-4 py-2">
              Catering
            </span>
          </motion.div>

          <div>
            <motion.p
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              className="flex items-center gap-2 text-[#da251d] uppercase tracking-[0.3em] text-xs font-semibold mb-4"
            >
              <PartyPopper size={16} /> Eventos y pedidos grandes
            </motion.p>
            <motion.h2
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7 }}
              className="font-display text-4xl md:text-6xl font-bold tracking-tight leading-none"
            >
              {content.events_heading}
            </motion.h2>
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.15 }}
              className="mt-6 text-[#57534e] text-lg leading-relaxed max-w-lg"
            >
              {content.events_text}
            </motion.p>

            <div className="mt-8 flex flex-col sm:flex-row gap-4">
              {wa && (
                <a
                  href={`https://wa.me/${wa}?text=${encodeURIComponent("Hola, quisiera cotizar catering para un evento.")}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="events-whatsapp-btn"
                  className="inline-flex items-center justify-center gap-2 rounded-full bg-[#da251d] text-white font-semibold px-8 py-4 transition-transform duration-200 hover:bg-[#b91c1c] active:scale-95"
                >
                  <MessageCircle size={18} /> Cotizar por WhatsApp
                </a>
              )}
              {content.phone && (
                <a
                  href={`tel:${content.phone.replace(/[^+\d]/g, "")}`}
                  data-testid="events-call-btn"
                  className="inline-flex items-center justify-center gap-2 rounded-full border border-stone-300 font-semibold px-8 py-4 transition-colors duration-200 hover:border-[#da251d] hover:text-[#da251d]"
                >
                  <Phone size={18} /> Llamar {content.phone}
                </a>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
